import {action, makeAutoObservable} from "mobx";
import CommonStore from "../../../stores/CommonStore";
import ArticleCategory from "../../../entities/productOrder/article/ArticleCategory";
import { ArticleCategoryService } from "../../../service/articleDelivery/ArticleCategoryService";

const ERROR_MAP = {
    name: ["ERROR_00_400_33"],
}

class NewArticleCategoryStore {

    public articleCategoryId?: string;
    public articleCategory: ArticleCategory;
    public isEditing: boolean;
    public isModalOpen: boolean;
    public loading: boolean;
    public nameError?: string;
    public commonStore: CommonStore;


    constructor(commonStore: CommonStore, articleCategoryId?: string) {
        this.isEditing = !!articleCategoryId;
        this.articleCategoryId = articleCategoryId;
        this.isModalOpen = false;
        this.articleCategory = {} as ArticleCategory;
        this.loading = false;
        this.commonStore = commonStore;
        makeAutoObservable(this);
    }

    get enableButton(): boolean {
        return !!(this.articleCategory?.name);
    }

    @action
    public async loadArticleCategory() {
        if (this.articleCategoryId) {
            this.isEditing = true;
            const response = await ArticleCategoryService.find(this.articleCategoryId!)
            if (response.success && response.data) {
                this.articleCategory = response.data;
            }
            this.commonStore.processErrors(response);
        }
    }

    @action
    public async openModal() {
        this.loading = true;
        await this.loadArticleCategory();
        this.isModalOpen = true;
        this.loading = false;
    }

    @action
    public closeModal() {
        this.isModalOpen = false;
    }

    @action
    public async save(): Promise<boolean> {
        this.loading = true;
        const serviceToCall = this.isEditing ? ArticleCategoryService.update : ArticleCategoryService.create;
        const response = await serviceToCall(this.articleCategory!!);
        this.commonStore.processErrors(response);
        this.processError(response.error);
        this.loading = false;
        return response.success;
    }

    processError(error?: string) {
        this.nameError = undefined;
        if (error) {
            if (ERROR_MAP.name.includes(error)) {
                this.nameError = error;
            }
        }

    }
}

export default NewArticleCategoryStore;

